import type { User } from "lib/apollo/types";
import { useUser as user } from "lib/user";

export function useUser(): Partial<User> {
  return user();
}
